interface BonusFormValues {
    amount: number | null;
    description: string;
}

export interface BonusFormErrors {
    amount?: string;
    description?: string;
}

export function validateBonus({
    amount,
    description,
}: BonusFormValues): BonusFormErrors {
    const errors: BonusFormErrors = {};

    if (!amount || amount <= 0) {
        errors.amount = 'Enter a bonus amount greater than $0.';
    }

    if (!description.trim()) {
        errors.description =
            'Enter a description. Nurses see this on the shift.';
    }

    return errors;
}
